import { useEffect, useState } from 'react';
import { api } from '../services/api';
import DynamicChart from '../components/chart/DynamicChart';  

type Typcont = { id: number; label: string };
type PortTypcont = {
  port: string;
  types: Typcont[];
};

type TypcontMap = {
  CONTRAT: Record<number, PortTypcont>;
  PASSAGE: Record<number, PortTypcont>;
}

export default function DynamicQueryCard() {
  const clientCode = localStorage.getItem('clientCode');

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<TypcontMap | null>(null);

  const [typeFiche, setTypeFiche] = useState<'CONTRAT' | 'PASSAGE'>('CONTRAT');
  const [typcontIds, setTypcontIds] = useState<number[]>([]);


  const SUBJECTS = [
    { key: 'libtypcont', label: 'Type de fiche' },
    { key: 'quantite', label: 'Total contrat' },
    { key: 'isopavillon', label: 'Pavillon' },
    { key: 'isopays', label: 'Pays' },
    { key: 'codpost', label: 'Département' },
    { key: 'libcatbat', label: 'Catégorie bateau' },
    { key: 'libtypbat', label: 'Type bateau' },
    { key: 'libtypcli', label: 'Type client' },
    ];

  const [subject, setSubject] = useState<string>(SUBJECTS[0].key);
  const [dateDeb, setDateDeb] = useState('');
  const [dateFin, setDateFin] = useState('');
  const [useToday, setUseToday] = useState(true);
  const [resultPayload, setResultPayload] = useState<any | null>(null);
  const [portId, setPortId] = useState<number | null>(null);



  

  // 🔹 Chargement initial
  useEffect(() => {
    api.get('/typefiche/typcont', { params: { clientCode } })
      .then(res => setData(res.data))
      .finally(() => setLoading(false));
  }, [clientCode]);

  const typcontList: Typcont[] = (() => {
    if (!data) return [];

    const byPort = data[typeFiche];

    if (portId && byPort[portId]) {
        return byPort[portId].types;
    }

    // Tous les ports → merge unique
    const map = new Map<number, Typcont>();
    Object.values(byPort).forEach(p =>
        p.types.forEach(t => map.set(t.id, t))
    );

    return Array.from(map.values());
    })();

  const executeQuery = () => {
    setResultPayload({
        typefiche: typeFiche,
        idport: portId,
        idtypcont: typcontIds.length > 0 ? typcontIds : null,
        subject,
        dateDeb,
        dateFin: useToday
            ? new Date().toISOString().slice(0, 10)
            : dateFin,
        });

    };

    const addTypcont = (id: number) => {
    if (!typcontIds.includes(id)) {
        setTypcontIds([...typcontIds, id]);
    }
    };

    const removeTypcont = (id: number) => {
    setTypcontIds(typcontIds.filter(t => t !== id));
    };

    
    const resetTypcont = () => {
    setTypcontIds([]);
    };
    
    const ports = data
    ? Object.entries(data[typeFiche]).map(([id, p]) => ({
        id: Number(id),
        label: p.port,
        }))
    : [];




  if (loading) return <div>Chargement…</div>;

  return (
            <div
        className="
            rounded-2xl border border-gray-200 dark:border-darkBorderCard
            bg-white dark:bg-white/[0.03]
            px-5 pb-5 pt-5 sm:px-6
        "
        >
        {/* Titre */}
        <h2 className="text-lg font-semibold mb-6 text-gray-800 dark:text-white/90">
            Graphique évolution
        </h2>

        {/* Formulaire */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

            {/* Type fiche */}
            <div className="flex flex-col gap-1">
            <label className="text-sm text-gray-600 dark:text-gray-400">
                Type de fiche
            </label>
            <select
                value={typeFiche}
                onChange={e => setTypeFiche(e.target.value as any)}
                className="
                rounded-lg border border-gray-300 dark:border-white/10
                bg-white dark:bg-darkMode
                px-3 py-2 text-sm
                text-gray-800 dark:text-white
                focus:outline-none focus:ring-2 focus:ring-blueLight
                "
            >
                <option value="CONTRAT">Contrat</option>
                <option value="PASSAGE">Passage</option>
            </select>
            </div>

            {/* Port */}
            <div className="flex flex-col gap-1">
            <label className="text-sm text-gray-600 dark:text-gray-400">
                Port
            </label>
            <select
                value={portId ?? ''}
                onChange={e => {
                const v = e.target.value;
                setPortId(v ? Number(v) : null);
                resetTypcont(); // 🔥 important : reset des types
                }}
                className="
                rounded-lg border border-gray-300 dark:border-white/10
                bg-white dark:bg-darkMode
                px-3 py-2 text-sm
                text-gray-800 dark:text-white
                focus:outline-none focus:ring-2 focus:ring-blueLight
                "
            >
                <option value="">Tous les ports</option>
                {ports.map(p => (
                <option key={p.id} value={p.id}>
                    {p.label}
                </option>
                ))}
            </select>
            </div>

            {/* Type contrat */}
            <div className="flex flex-col gap-2">
            <label className="text-sm text-gray-600 dark:text-gray-400">
                Type de contrat
            </label>

            {/* Select (ajout uniquement) */}
            <select
                value={typcontIds.length === 0 ? '' : '__ADD__'}
                onChange={e => {
                    const value = e.target.value;

                    if (value === '') {
                    // 👉 Tous les types = reset
                    resetTypcont();
                    return;
                    }

                    if (value === '__ADD__') return;

                    addTypcont(Number(value));
                }}
                className="
                    rounded-lg border border-gray-300 dark:border-white/10
                    bg-white dark:bg-darkMode
                    px-3 py-2 text-sm
                    text-gray-800 dark:text-white
                    focus:outline-none focus:ring-2 focus:ring-blueLight
                "
                >

            <option key="0" value="">
                Tous les types
            </option>

            <option value="__ADD__" disabled hidden>
                Ajouter un type…
            </option>


            {typcontList.map(t => (
                <option
                key={t.id}
                value={t.id}
                disabled={typcontIds.includes(t.id)}
                >
                {t.label}
                </option>
            ))}
            </select>

            {/* Puces */}
            {typcontIds.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-1">
                {typcontIds.map(id => {
                    const label = typcontList.find(t => t.id === id)?.label;
                    return (
                    <span
                        key={id}
                        className="
                        inline-flex items-center gap-1
                        rounded-full bg-blue-100 dark:bg-blue-900/40
                        px-3 py-1 text-xs font-medium
                        text-blue-800 dark:text-blue-200
                        "
                    >
                        {label}
                        <button
                        type="button"
                        onClick={() => removeTypcont(id)}
                        className="ml-1 text-blue-600 dark:text-blue-300 hover:text-red-500"
                        >
                        ✕
                        </button>
                    </span>
                    );
                })}
                </div>
            )}
            </div>


            {/* Sujet */}
            <div className="flex flex-col gap-1">
            <label className="text-sm text-gray-600 dark:text-gray-400">
                Sujet analysé
            </label>
            <select
                value={subject}
                onChange={e => setSubject(e.target.value)}
                className="
                rounded-lg border border-gray-300 dark:border-white/10
                bg-white dark:bg-darkMode
                px-3 py-2 text-sm
                text-gray-800 dark:text-white
                focus:outline-none focus:ring-2 focus:ring-blueLight
                "
            >
                {SUBJECTS.map(s => (
                <option key={s.key} value={s.key}>
                    {s.label}
                </option>
                ))}
            </select>
            </div>



            {/* Date début */}
            <div className="flex flex-col gap-1">
            <label className="text-sm text-gray-600 dark:text-gray-400">
                Date de début
            </label>
            <input
                type="date"
                value={dateDeb}
                onChange={e => setDateDeb(e.target.value)}
                className="
                rounded-lg border border-gray-300 dark:border-white/10
                bg-white dark:bg-darkMode
                px-3 py-2 text-sm
                text-gray-800 dark:text-white
                focus:outline-none focus:ring-2 focus:ring-blueLight
                "
            />
            </div>

            {/* Date fin */}
            <div className="flex flex-col gap-1">
            <label className="text-sm text-gray-600 dark:text-gray-400">
                Date de fin
            </label>
            <input
                type="date"
                value={dateFin}
                disabled={useToday}
                onChange={e => setDateFin(e.target.value)}
                className={`
                rounded-lg border px-3 py-2 text-sm
                ${useToday
                    ? 'bg-gray-100 dark:bg-darkDarkGray text-gray-400'
                    : 'bg-white dark:bg-darkMode text-gray-800 dark:text-white'}
                border-gray-300 dark:border-white/10
                focus:outline-none focus:ring-2 focus:ring-blueLight
                `}
            />
            </div>

            {/* Checkbox */}
            <div className="flex items-center gap-2 mt-6">
            <input
                type="checkbox"
                checked={useToday}
                onChange={e => setUseToday(e.target.checked)}
                className="h-4 w-4 accent-blueLight"
            />
            <span className="text-sm text-gray-600 dark:text-gray-400">
                Jusqu’à aujourd’hui
            </span>
            </div>
        </div>

        {/* Bouton */}
        <div className="mt-6 flex justify-end">
            <button
            onClick={executeQuery}
            className="
                inline-flex items-center gap-2
                rounded-lg bg-blueLight
                px-5 py-2 text-sm font-medium text-white
                hover:bg-indigo-700
                transition
            "
            >
            Exécuter l’analyse
            </button>
        </div>

        {/* Résultat */}
        {resultPayload && (
            <DynamicChart
            clientCode={clientCode!}
            payload={resultPayload}
            className="mt-6"
            />
        )}
        </div>


     

    
  );
}
